// extracted by mini-css-extract-plugin
module.exports = {"ExternalLink":"ExternalLink_ExternalLink__3S-GC"};